import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import api from '../utils/api'

const PaymentResult = () => {
  const [searchParams] = useSearchParams()
  const txnid = searchParams.get('txnid')
  const redirectStatus = searchParams.get('status')
  const [loading, setLoading] = useState(Boolean(txnid))
  const [payment, setPayment] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    const fetchPaymentStatus = async () => {
      if (!txnid) {
        setError('Payment transaction ID is missing.')
        setLoading(false)
        return
      }

      try {
        const response = await api.get(`/orders/payment/status/${txnid}`)
        setPayment(response.data.payment)
      } catch (err) {
        console.error('Payment status error:', err)
        setError(err.response?.data?.message || 'Unable to confirm payment status. Please check your orders or contact support.')
      } finally {
        setLoading(false)
      }
    }

    fetchPaymentStatus()
  }, [txnid])

  const status = payment?.payment_status || redirectStatus || 'failed'
  const isPaid = status === 'paid'
  const isInitiated = status === 'initiated'

  return (
    <div className="page-container">
      <div className="glass-card" style={{ maxWidth: '680px', margin: '3rem auto', padding: '2rem', textAlign: 'center' }}>
        {loading ? (
          <>
            <div className="spinner" style={{ margin: '0 auto 1rem' }}></div>
            <h2>Confirming Payment</h2>
            <p className="text-secondary">Please wait while we confirm your PayU payment.</p>
          </>
        ) : (
          <>
            <h2>{isPaid ? 'Payment Successful' : isInitiated ? 'Payment Pending' : 'Payment Failed'}</h2>
            <p className="text-secondary">
              {isPaid
                ? 'Your order has been placed successfully.'
                : isInitiated
                  ? 'Your payment is still pending. Please refresh this page after a few moments.'
                  : 'We could not complete this payment. You can retry the order from the products page.'}
            </p>

            {error && <div className="error-message" style={{ marginTop: '1rem' }}>{error}</div>}

            {payment && (
              <div className="order-summary" style={{ textAlign: 'left', marginTop: '1.5rem' }}>
                <div className="summary-row">
                  <span>Transaction ID:</span>
                  <strong>{payment.order_id}</strong>
                </div>
                {payment.payment_id && (
                  <div className="summary-row">
                    <span>PayU Reference:</span>
                    <strong>{payment.payment_id}</strong>
                  </div>
                )}
                <div className="summary-row">
                  <span>Amount:</span>
                  <strong>Rs. {Number(payment.amount || 0).toFixed(2)}</strong>
                </div>
              </div>
            )}

            <div className="action-buttons mt-6" style={{ justifyContent: 'center' }}>
              {isPaid ? (
                <Link className="btn btn-primary" to="/orders">View My Orders</Link>
              ) : (
                <Link className="btn btn-primary" to="/products">Retry Payment</Link>
              )}
              <Link className="btn btn-secondary ml-2" to="/">Go Home</Link>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PaymentResult
